

import { Select } from 'antd';
import { useEffect, useState } from 'react';
import { useSessionData } from '../../../Contexts/SessionDataContext';
import { useAppConfig } from '../../../Contexts/AppConfigContext';
import { UserCommisionConfiguration } from '../../../models/UserSessionData';
import './CommissionConfigurationSelector.scss';

const CommissionConfigurationSelector = (): JSX.Element => {
    const sessionData = useSessionData();
    const appConfig = useAppConfig();
    const configurations = appConfig.config.userCommissionConfiguration ?? [];

    const getInitialValue = (): string | undefined => {
        if (sessionData.userData.commissionConfigurationSelected) {
            const cached = sessionData.userData.commissionConfigurationSelected;
            if (configurations.some(c => c.id === cached)) {
                return cached;
            }
        }
        const base = configurations.find(c => c.isBase);
        if (base) return base.id;
        return configurations.length > 0 ? configurations[0].id : undefined;
    };

    const [selectedId, setSelectedId] = useState<string | undefined>(getInitialValue);

    useEffect(() => {
        if (configurations.length > 0) {
            const initial = getInitialValue();
            if (!selectedId || !configurations.some(c => c.id === selectedId)) {
                setSelectedId(initial);
            }
            if (initial) {
                updateSessionData(initial);
            }
        } else {
            setSelectedId(undefined);
        }
    }, [configurations.length]);

    const updateSessionData = (value: string) => {
        const config = configurations.find(c => c.id === value);
        const { setSessionData, ...currentData } = sessionData;
        const updated = {
            ...currentData,
            userData: {
                ...currentData.userData,
                commissionConfigurationSelected: value,
                isBase: config?.isBase ?? false
            }
        };
        setSessionData(updated);
        sessionStorage.setItem("user-data", JSON.stringify(updated));
    };

    const handleChange = (value: string) => {
        setSelectedId(value);
        updateSessionData(value);
    };

    if (configurations.length === 0) {
        return <></>;
    }

    return (
        <Select
            className="app-input "
            value={selectedId}
            onChange={handleChange}
        >
            {configurations.map((config: UserCommisionConfiguration) => (
                <Select.Option key={config.id} value={config.id}>
                    {config.name}
                </Select.Option>
            ))}
        </Select>
    );
};

export default CommissionConfigurationSelector;

